// extracted by mini-css-extract-plugin
export var alertIcon = "_nf-0";